// src/pages/Auditorias/components/SeccaoColapsavel.js
import React, { useState } from 'react';

/**
 * Secção colapsável do detalhe. Mesmo comportamento do CollapsibleSection.js de
 * ClientData, com classes próprias desta página.
 *
 * onAbrir dispara à primeira abertura — é o que permite carregar problemas e
 * ficheiros a pedido em vez de trazer tudo com o detalhe.
 */
const SeccaoColapsavel = ({ titulo, resumo, badge, defaultOpen = false, onAbrir, children }) => {
  const [aberta, setAberta] = useState(defaultOpen);
  const [jaAbriu, setJaAbriu] = useState(defaultOpen);

  const alternar = () => {
    const proxima = !aberta;
    setAberta(proxima);
    if (proxima && !jaAbriu) {
      setJaAbriu(true);
      onAbrir?.();
    }
  };

  // Carregamento inicial quando a secção nasce aberta
  React.useEffect(() => {
    if (defaultOpen) onAbrir?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={`aud-seccao ${aberta ? 'aberta' : 'fechada'}`}>
      <button type="button" className="aud-seccao-cabecalho" onClick={alternar}>
        <span className="aud-seccao-seta" aria-hidden="true">{aberta ? '▾' : '▸'}</span>
        <span className="aud-seccao-titulo">{titulo}</span>
        {badge}
        {resumo && <span className="aud-seccao-resumo">{resumo}</span>}
      </button>
      {aberta && <div className="aud-seccao-corpo">{children}</div>}
    </div>
  );
};

export default SeccaoColapsavel;
